import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { BoardResolutionModel } from '../model';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: BoardResolutionModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class BoardResolutionStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<BoardResolutionModel>((_, data) => ({ state: 'valid', data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
